//import '@babel/polyfill' from vuetify

import jQuery from 'jquery'
//import 'bootstrap'
//import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vuetify/dist/vuetify.min.css'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
//import './plugins/vuetify'
import JManApp from './JManApp'
import store from './store'
import router from './router'

global.jQuery = jQuery

Vue.config.productionTip = false

Vue.use(Vuetify, {
  iconfont: 'fa',
  theme: {
	  primary: "#03A9F4",
	  secondary: "#e57373",
	  accent: "#9c27b0",
	  error: "#f44336",
	  warning: "#ffeb3b",
	  info: "#2196f3",
	  success: "#4caf50"
	}
});

// Register component globally
import JmCell from './components/widgets/Cell'
Vue.component('JmCell', JmCell);

// Start polling the server
store.dispatch('dbsync/startRefresh');

new Vue({
	el: '#jman-app',
	store,
	router,
	components: { JManApp },
	template: '<JManApp/>'
})



// WEBPACK FOOTER //
// ./src/main.js